import * as IoC from 'typescript-ioc';
import * as mobx from 'mobx';
import { IAccountAdminDAO } from '../../../api/account-admin';
import { IReactIntlProvider } from '../../../infrastructure/react-intl-provider';
import { AccountAdminSettingEntity } from './account-admin-setting.entity';
import { IntlShape, MessageDescriptor } from 'react-intl';
import { handleApiException, showNotification } from '../../global/modal/alerts-host/alert-templates';

abstract class BaseAccountAdminSettingViewModel {
    @mobx.observable
    public saving: boolean = false;

    constructor(
        protected readonly entity: AccountAdminSettingEntity,
        @IoC.Inject protected readonly accountAdminDAO: IAccountAdminDAO = IoC.Container.get(IAccountAdminDAO),
        @IoC.Inject protected readonly intlProvider: IReactIntlProvider = IoC.Container.get(IReactIntlProvider),
    ) { }

    public get settingsEntity(): AccountAdminSettingEntity {
        return this.entity;
    }

    public get intl(): IntlShape {
        return this.intlProvider.getIntl();
    }

    @mobx.action
    public handleSubmit = async (): Promise<boolean> => {
        if (this.shouldInterruptSubmit()) {
            this.onInteruptHandler();
            return false;
        }

        try {
            mobx.runInAction(() => {
                this.saving = true;
            });
            await this.apiCall();
            mobx.runInAction(() => {
                this.entity.updateSnapshot();
            });
            showNotification(this.intl.formatMessage(this.notificationMessage));
            return true;
        } catch (error) {
            handleApiException(error);
            return false;
        } finally {
            mobx.runInAction(() => {
                this.saving = false;
            });
        }
    };

    public handleClose = (): boolean => {
        this.entity.reset();

        return true;
    };

    // All the functions below are abstract and should be implemented in the child classes

    // Retrieves a message descriptor for notifications.
    abstract get notificationMessage(): MessageDescriptor;

    // Executes an API call
    abstract apiCall(): Promise<void>;

    // Determines if the submit process should be interrupted.
    protected shouldInterruptSubmit(): boolean {
        return this.saving;
    }

    // Handler for interruptions during the submit process
    // eslint-disable-next-line
    protected onInteruptHandler(): boolean | void { }

}

export { BaseAccountAdminSettingViewModel };